import { OwnerType } from '@vendasta/smsv2';

export enum RegistrationType {
  A2P_REGISTRATION = 'a2p_registration',
  REGULATORY_COMPLIANCE = 'regulatory_compliance',
  NONE = 'none',
}

export interface OwnerLocation {
  ownerId: string;
  ownerType: OwnerType;
  streetAddress?: string;
  streetAddressSecondary?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}
